'use strict';
const angular = require('angular');
const {extend} = angular;
import {stateGo} from 'redux-ui-router';
import {storage} from '../../config/constants';

module.exports = [
  '$injector',
  '$ngRedux',
  WizardManagerService];

function WizardManagerService(
  $injector,
  $ngRedux,
) {

  var WIZARD_STATE = 'WIZARD_STATE';
  var currentState = null;
  var wizard;

  this.start = start;
  this.resume = resume;
  this.performAction = performAction;
  this.inWizard = inWizard;
  this.destroy = destroy;
  this.$$update = update; // intended to only be called by implementations of wizards
  this.$$getState = getState;

  /**
   * @param wizardName: name of the injectable wizard service to begin
   */
  function start(wizardName) {
    if (inWizard()) throw new Error("Attempting to begin a new wizard while one is progress!");

    update({
      serviceName: wizardName
    });

    _beforeAction();
    wizard.start(this);
  }

  function resume() {
    if (!inWizard()) throw new Error("Attempting to resume a wizard but none is in progress!");

    wizard = $injector.get(currentState.serviceName);

    if (currentState.resumePoint) {
      wizard.resume(this);

      if (currentState.resumePoint.params) {
        $ngRedux.dispatch(stateGo(currentState.resumePoint.name, currentState.resumePoint.params));
      } else {
        $ngRedux.dispatch(stateGo(currentState.resumePoint.name));
      }
    } else {
      // Fallback to destroying the wizard data if there is no recovery available
      destroy();
    }
  }

  function performAction(actionName, actionParams) {
    if (!wizard) throw new Error("This is no wizard in progress!");

    _beforeAction();
    wizard.performAction(actionName, actionParams);
  }

  // Check if a wizard is in progress to resume
  function inWizard() {
    currentState = storage.get(WIZARD_STATE);
    return !!currentState;
  }

  // Clean up the wizard's data
  function destroy() {
    currentState = null;
    wizard = null;
    storage.set(WIZARD_STATE, null);
  }

  function _beforeAction(actionName, actionParams) {
    wizard = wizard ? wizard : $injector.get(currentState.serviceName);

    var state = wizard.getResumePoint(actionName ? actionName : 'start', actionParams);

    update({
      resumePoint: {
        name: state.name,
        prms: state.params ? state.params : null
      }
    });
  }

  function update(state) {
    currentState = extend(currentState ? currentState : {}, state);
    storage.set(WIZARD_STATE, currentState);
  }

  function getState(prop) {
    return !currentState ? null : currentState[prop];
  }

}


// WEBPACK FOOTER //
// ./src/js/core-utilities/wizards/WizardManagerService.js